import cn from 'classnames';
import React from 'react';

import s from './index.scss';

const Cpt = ({title, content, onClose}) => (
    <div
        className={cn(s.fullscreen)}
    >
        <nav>
            <button onClick={onClose} />
            <h1>{title}</h1>
        </nav>
        <div className={s.content}>
            <div className={s.inner}>
                <div>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </div>
            </div>
        </div>
    </div>
);

export default Cpt;
